import type { Bucket } from '@enonic-types/core';
import { ucFirst } from './ucFirst';

export function humanizeCountyBuckets(countyBuckets: Bucket[]): Bucket[] {
	return countyBuckets.map(({docCount, key}) => ({
		docCount,
		key: key === 'møre og romsdal' ? 'Møre og Romsdal' : ucFirst(key),
	}));
}
